import styled, { css, keyframes } from 'styled-components';
import { down } from 'styled-breakpoints';

export const Container = styled.article`
  ${({ theme }) => css`
    display: flex;
    gap: 0;
    margin: -${theme.spacing[6]};
    min-height: calc(100vh - ${theme.layout.header});

    ${down('lg')} {
      margin: -${theme.spacing[4]};
    }

    ${down('md')} {
      margin: -${theme.spacing[3]};
    }
  `}
`;

export const MainContent = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;

export const Sidebar = styled.aside`
  ${({ theme }) => css`
    width: 420px;
    flex-shrink: 0;
    border-left: 1px solid ${theme.colors.background[40]};
    background: ${theme.colors.background[100]};
    position: sticky;
    top: ${theme.layout.header};
    height: calc(100vh - ${theme.layout.header});
    overflow: hidden;

    ${down('xl')} {
      display: none;
    }
  `}
`;

export const Banner = styled.div`
  width: 100%;
  overflow: hidden;
  margin-bottom: 1.5rem;
  position: relative;
  background: linear-gradient(135deg, #667eea, #764ba2);

  > img {
    width: 100%;
    height: auto;
    aspect-ratio: 16 / 4;
    object-fit: cover;
    display: block;
  }

  ${down('md')} {
    margin-bottom: 1rem;

    > img {
      aspect-ratio: 16 / 5;
    }
  }
`;

export const BannerDots = styled.div`
  position: absolute;
  bottom: 0.75rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 0.375rem;
`;

export const BannerDot = styled.div<{ $active?: boolean }>`
  width: ${({ $active }) => ($active ? '1.25rem' : '0.375rem')};
  height: 0.375rem;
  border-radius: 0.1875rem;
  background: ${({ $active }) =>
    $active ? 'white' : 'rgba(255, 255, 255, 0.4)'};
  transition: all 0.3s ease;
`;

export const ContentWrapper = styled.div`
  padding: 0 2.25rem 2.25rem;
  max-width: 1360px;
  margin: 0 auto;

  ${down('md')} {
    padding: 0 1rem 1.5rem;
  }
`;

export const Section = styled.section`
  margin-bottom: 2.95rem;

  > header {
    max-width: 100%;
    margin-bottom: 0.875rem;

    a {
      font-size: 0.875rem;
    }
  }
`;

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
`;

export const PulseLive = styled.span`
  animation: ${pulse} 2s infinite;
`;
